const PALETTE = [
  "#7C3AED", // purple
  "#0EA5E9", // sky
  "#22C55E", // green
  "#F97316", // orange
  "#06B6D4", // cyan
  "#E11D48", // rose
  "#8B5CF6", // violet
  "#10B981", // emerald
  "#F59E0B", // amber
  "#6366F1"  // indigo
];

const hashString = (value: string): number => {
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return Math.abs(hash);
};

export const getDeterministicColor = (userId: string): string => {
  if (!userId) return PALETTE[0];
  const hash = hashString(userId);
  return PALETTE[hash % PALETTE.length];
};

export const colorPalette = PALETTE;
